import React from "react";
import { motion } from "framer-motion";
import logo from "./smart_realty_for_app-12.png";
import QrCode from "./qr-code.png"
const appStore = require("../assets/images/applePlay.png");
const playStore = require("../assets/images/googleStore.png");

const container = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.12,
      ease: "easeOut",
    },
  },
};

const item = {
  hidden: { opacity: 0, y: 24 },
  show: { opacity: 1, y: 0, transition: { duration: 0.6 } },
};


export default function SmartAppLanding() {
    const StoreButton = ({ img, url }) => (
  <motion.a
    href={url}
    target="_blank"
    rel="noopener noreferrer"
    className="relative z-20 inline-flex items-center bg-black/70 rounded-xl px-6 py-3 shadow-lg cursor-pointer"
    whileHover={{ scale: 1.05 }}
    whileTap={{ scale: 0.97 }}
  >
    <img
      src={img}
      alt="Store"
      className="h-12 pointer-events-none select-none"
    />
  </motion.a>
);

  return (
    <section className="min-h-screen w-full bg-gradient-to-br from-black via-slate-900/90 to-indigo-900 text-white flex items-center py-10">
      <div className="max-w-7xl mx-auto w-full px-6">

        <motion.div
          className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center"
          variants={container}
          initial="hidden"
          animate="show"
        >

          {/* LEFT */}
          <motion.div variants={item}>
            <span className="inline-block mb-4 px-4 py-1 rounded-full text-sm bg-indigo-500/20 text-indigo-300">
              Real Estate • Social • Voice
            </span>

            <h1 className="text-4xl md:text-6xl font-extrabold leading-tight">
              Smart Realty App
              <span className="block text-indigo-400 mt-2">
                Property meets social experience
              </span>
            </h1>

            <p className="mt-6 text-lg text-gray-300 max-w-xl">
              Discover properties, watch real estate videos, post updates,
              and connect instantly through live audio rooms.
            </p>

            <motion.div
              className="mt-8 grid grid-cols-2 gap-4 max-w-md"
              variants={container}
            >
              {[
                "🏡 Property Listings",
                "🎥 Short Videos",
                "📝 Social Posts",
                "🎧 Live Audio Chat",
              ].map((text) => (
                <motion.div
                  key={text}
                  variants={item}
                  className="bg-white/5 border border-white/10 rounded-lg px-4 py-3 text-sm"
                >
                  {text}
                </motion.div>
              ))}
            </motion.div>

         <motion.div variants={item} className="mt-10 flex gap-4 relative z-20">
  <StoreButton
    img="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg"
    url="https://play.google.com/store/apps/details?id=com.realityapp"
  />
  <StoreButton
    img="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg"
    url="https://apps.apple.com/us/app/smart-app/id1521331431"
  />
</motion.div>

           
           
            
          </motion.div>

          {/* RIGHT */}
          <motion.div
            variants={item}
            className="flex flex-col items-center gap-10"
          >
            {/* Logo / App */}
            <motion.img
              src={logo}
              alt="Smart App"
              className="w-[260px] md:w-[340px] drop-shadow-2xl"
              whileHover={{ scale: 1.04 }}
              transition={{ type: "spring", stiffness: 200, damping: 18 }}
            />

            {/* QR */}
            <motion.div
              className="bg-white rounded-2xl p-4 shadow-2xl"
              initial={{ opacity: 0, y: 16 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.4, duration: 0.5 }}
            >
              <img
                src={QrCode}
                alt="Download Smart App"
                className="w-44 h-44"
              />
              <p className="mt-3 text-sm text-gray-700 text-center font-medium">
                Scan to download
              </p>
            </motion.div>
          </motion.div>

        </motion.div>
      </div>
    </section>
  );
}

const StoreButton = ({ img }) => (
  <motion.a
    href="#"
    whileHover={{ scale: 1.05 }}
    whileTap={{ scale: 0.97 }}
    className="bg-black rounded-xl px-6 py-3 shadow-lg"
  >
    <img src={img} className="h-12" />
  </motion.a>
);
